const firebaseConfig = {
    apiKey: "AIzaSyBx5l050BcqB9atW9eBfJCrK0DjBbzBUHA",
    authDomain: "telecare-c08e9.firebaseapp.com",
    projectId: "telecare-c08e9",
    storageBucket: "telecare-c08e9.appspot.com",
    messagingSenderId: "523413764868",
    appId: "1:523413764868:web:9f1ab6c2d54c3767252e51"
};

export default firebaseConfig;